import React, { useState, useEffect, useMemo } from "react";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";
import AuthingSSO from "@authing/sso";

import { Title } from "../../components/Title";
import { WxModal } from "./wx-modal";
import "./styles.less";

const isBrowser =
  typeof window !== "undefined" && typeof window.navigator !== "undefined";

let CodeMirror = null;
if (isBrowser) {
  const { Controlled } = require("react-codemirror2");
  CodeMirror = Controlled;
  require("codemirror/lib/codemirror.css");
  require("codemirror/theme/material.css");
  require("codemirror/mode/htmlembedded/htmlembedded");
}

let authing = null;
if (isBrowser) {
  authing = new AuthingSSO({
    appId: "5d70d0e991fdd597019df70d",
    appType: "oidc", // 默认 oidc
    appDomain: "sample-sso.authing.cn",
    redirectUrl: "https://authing.cn/developer",
  });
}

export const DeveloperStatus = () => {
  const [loginState, setLoginState] = useState(false);
  const [wxLoginVisible, setWxLoginVisible] = useState(false);

  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [response, setResponse] = useState(null);

  const logout = async () => {
    if (isBrowser) {
      await authing.logout();
      setResponse(null);
      setLoginState(false);
    }
  };
  const login = async () => {
    if (isBrowser) {
      await authing.login();
    }
  };
  useEffect(() => {
    if (isBrowser) {
      (async () => {
        const res = await authing.trackSession();
        if (!res.session) {
          setLoginState(false);
        } else {
          setLoginState(true);
          setResponse(res);
        }
        setLoading(false);
      })();
    }
  }, []);

  const loginText = useMemo(() => {
    const username = response?.userInfo?.username;
    const email = response?.userInfo?.email;
    const nickname = response?.userInfo?.nickname;
    const handleNull = (res) => {
      if (res === "null" || res === null) {
        return undefined;
      }
      return res;
    };
    return loginState
      ? `${
          handleNull(username) ||
          handleNull(email) ||
          handleNull(nickname) ||
          ""
        }${t("developer.status.login")}`
      : t("developer.status.unLogin");
  }, [loginState, response, t]);

  return (
    <div>
      <section id="sso" className="developer-status">
        <div className="inner">
          <Title
            title={`${t("developer.status.currentStatus")}：${loginText}`}
          ></Title>
          <div className="status-box">
            <div className="item">
              <div className="img">
                <img
                  src={"//files.authing.co/authing-website/sample-web-icon.svg"}
                  alt="authing developer"
                />
              </div>
              <div className="title">{t("developer.status.web")}</div>
              <a
                href="https://docs.authing.cn/v2/reference/sdk-for-sso.html"
                target="_blank"
                rel="noopener noreferrer"
                className="button link"
              >
                {t("developer.button.doc")}
              </a>
              {loginState ? (
                <div
                  className="button cancel"
                  onClick={() => {
                    logout();
                  }}
                >
                  {t("developer.button.logout")}
                </div>
              ) : (
                <div
                  className="button done"
                  onClick={() => {
                    login();
                  }}
                >
                  {t("developer.button.experience")}
                </div>
              )}
            </div>
            <div className="item">
              <div className="img">
                <img
                  src={"//files.authing.co/authing-website/sample-app-icon.svg"}
                  alt="authing developer "
                />
              </div>
              <div className="title">{t("developer.status.app")}</div>
              <div
                onClick={() => setWxLoginVisible(true)}
                className="button done"
              >
                {t("developer.button.experience")}
              </div>
            </div>
          </div>

          {loginState && (
            <div className="session-info">
              <div className="session-title">
                {t("developer.status.session")}
              </div>
              <div className="session-content">
                <div className="top">
                  {loading}
                  {t("developer.status.sessionTitle")}
                </div>
                {loading && (
                  <div className="loading-mask">
                    <ReactLoading
                      type="spin"
                      color="#215ae5"
                      height={60}
                      width={60}
                    />
                  </div>
                )}
                {response && CodeMirror && (
                  <CodeMirror
                    value={response ? JSON.stringify(response, null, 2) : "{}"}
                    autoScroll={false}
                    className="react-codemirror2"
                    options={{
                      //   mode: "htmlembedded",
                      mode: { name: "javascript", json: true },
                      theme: "material",
                      lineNumbers: true,
                    }}
                  />
                )}
              </div>
            </div>
          )}
        </div>

        <WxModal visible={wxLoginVisible} setVisible={setWxLoginVisible} />
      </section>
    </div>
  );
};
